/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit-outlined': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M14.525 3.041c-.471.117-.85.453-1.078.681l-.743.744 2.824 2.825.743-.743c.243-.243.577-.62.69-1.087.1-.413.05-.998-.69-1.739-.738-.738-1.327-.784-1.746-.68zm.296 4.957l-2.824-2.825L3 14.174V17h2.824l8.997-9.002zm-.536-5.927c.805-.2 1.742-.007 2.693.944.948.948 1.15 1.878.955 2.682-.183.753-.694 1.297-.955 1.558L6.528 17.71a.99.99 0 01-.704.29H3a1 1 0 01-1-1v-2.826a.99.99 0 01.29-.703L12.74 3.015c.249-.249.792-.758 1.545-.944z" _fill="#1D3861"/>'
  }
})
